import { render, staticRenderFns } from "./FlashMessages.vue?vue&type=template&id=2b584fdb&"
import script from "./FlashMessages.vue?vue&type=script&lang=js&"
export * from "./FlashMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports